import { __assign as e } from "../../tslib/tslib.es6.js";
import { noCase as r } from "../../no-case/dist.es2015/index.js";
import { upperCaseFirst as s } from "../../upper-case-first/dist.es2015/index.js";
function t(e, r) {
  var t = e.toLowerCase();
  return 0 === r ? s(t) : t;
}
function i(s, i) {
  return void 0 === i && (i = {}), r(s, e({
    delimiter: " ",
    transform: t
  }, i));
}
export { i as sentenceCase, t as sentenceCaseTransform };